var exports = {
  "K": "IconButton__P-rr7d",
};

module.exports = exports;
